module.exports = __webpack_public_path__ + "static/insurance3-ae0604eb3693885dea41ed9dd6da1a8b.png";